<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='90px' ref='form' :model='form'>
        <el-row>
          <el-col :span='14'>
            <el-form-item label='日期：'>
              <el-date-picker
                v-model='form.startTimeStr'
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                clearable
                type='datetime'
                placeholder='请选择开始时间'
              ></el-date-picker>
              <span style='margin: 0 5px'>至</span>
              <el-date-picker
                v-model='form.endTimeStr'
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                clearable
                type='datetime'
                placeholder='请选择结束时间'
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span='5'>
            <el-form-item label='来电号码：'>
              <el-input
                clearable
                placeholder='请输入'
                v-model='form.caller'
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='3' :offset='2'>
            <el-button
              type='primary'
              class='searchBtns'
              @click='chalist'
            >查询
            </el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div>
      <el-table
        :data='tableData'
        border
        style='width: 100%'
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          type='index'
          width='70'
          label='序号'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='caller'
          label='来电号码'
          align='center'
          width='250'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='callInTime'
          label='来电时间'
          align='center'
          width='200'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!-- <el-table-column
            prop="reason"
            label="漏接原因"
            align="center"
            width="200"
            :show-overflow-tooltip="true"
        >
        </el-table-column> -->
        <el-table-column
          prop='customerName'
          label='姓名'
          align='center'
          width='200'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column label='处理状态' align='center'>
          <template slot-scope='scope'>
            <span v-if='scope.row.handleStatus == 0'>未处理 </span>
            <span v-if='scope.row.handleStatus == 1'>已处理 </span>
          </template>
        </el-table-column>
        <el-table-column
          prop='handler'
          label='处理人'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column label='操作' align='center' width='100'>
          <template slot-scope='scope'>
            <el-button type='text' @click.stop='callBack(scope.row)'
            >回拨
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='pagination_container'>
      <el-pagination
        :page-sizes='[10, 20, 50, 100]'
        :page-size='pageSize'
        :current-page.sync='pageNo'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
        @size-change='handletableDataSize'
        @current-change='handleTableDataChange'
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headLine from '../components/headline'
import exportVue from '@/utils/exportVue'

export default {
  components: {
    headLine
  },
  data() {
    return {
      value1: '',
      form: {
        startTimeStr: '',
        endTimeStr: '',
        caller: ''
      },
      tableData: [],
      pageSize: 10,
      total: 0,
      pageNo: 1,
      belongAddressId: '1856cf78-bd6a-45bf-afd4-b553f3da443f',
      callTool: {},
      isSearchContent: true
    }
  },
  created() {
  },
  mounted() {
    this.getlist()
    setTimeout(() => {
      this.initCall()
    }, 0)
  },
  methods: {
    Reset() {
      this.form = {}
      this.chalist()
    },
    initCall() {
      const that = this
      that.callTool = new ghToolbar('mySoftphone')
      console.log(that.callTool, '第三方插件')
    },
    callBack(e) {
      const data = {
        status: 1,
        operateId: e.id,
        caller: e.caller
      }
      if (e.caller == null || e.caller == '') {
        this.$message.warning('号码无效，暂无法拨号')
      } else {
        this.$store.dispatch('setPhone', e.caller)
        exportVue.$emit('question', true)
      }
      // var r = this.callTool.Dial(e.caller.trim())
      // if (!r) {
      //     this.$message({
      //         showClose: true,
      //         message: "外拨失败-1",
      //         type: "error",
      //         offset: 50,
      //     })
      //     // 坐席外呼失败 取消外呼 调用该方法后会触发事件 线路状态改变 OnLineStateChanged
      //     this.callTool.CancelDial()
      // } else {
      //     // 坐席呼出后触发该事件 呼出结果（TRUE=成功、FALSE=失败）
      //     this.callTool.OnAgentDial((bResult) => {
      //         if (!bResult) {
      //             this.$message({
      //                 showClose: true,
      //                 message: "外拨失败-2",
      //                 type: "error",
      //                 offset: 50,
      //             })
      //             this.callTool.CancelDial()
      //         } else {
      //             // 坐席外呼接通
      //             this.callTool.OnDialConnected()
      //         }
      //     })
      // }
    },
    // 分页切换
    handletableDataSize(val) {
      this.pageSize = val
      this.getlist()
    },
    // 分页切换
    handleTableDataChange(val) {
      this.pageNo = val
      this.getlist()
    },
    //获取表格数据列表
    getlist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
        // belongAddressId: this.belongAddressId,
        // ...this.form,
      }
      this.comlist(params)
      console.log(this.form.caller)
      if ((this.form.caller = 'null')) {
        this.form = {}
      }
    },
    comlist(params) {
      //公共
      this.$http
        .request({
          url: '/jjyl/traffic/lostCall/info/findList',
          method: 'POST',
          data: params
        })
        .then((res) => {
          if (res.code === 200) {
            console.log(res.content, 'console.content')
            if (res.content && res.content.list) {
              this.tableData = res.content.list
              this.total = res.content.count
              console.log(this.form.caller)
            }
          }
        })
    },
    chalist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        // belongAddressId: this.belongAddressId,
        ...this.form
      }
      this.comlist(params)
    }
  }
}
</script>

<style lang='less' scoped>
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
